<template>
    
    <b-table class="table is-fullwidth" :hoverable="true" :data='fetchClassrooms'>
      <b-loading v-model="isLoading" :is-full-page="true"></b-loading>
      <b-table-column label="Name" v-slot="props" sortable>
        {{ props.row.name }}
        </b-table-column>
        <b-table-column label="Action" class="is-actions-cell" v-slot="props">
          <div class="buttons is-right" style="display:block">
            <b-button class="button is-small is-primary" @click="$router.push({ name: 'classroom-details', params: { id: props.row._id } })" type="button">
                <b-icon
                    icon="eye"
                    size="is-small">
                </b-icon>
            </b-button>
            <b-button class="button is-small is-primary" @click="editClassroom(props.row._id)"  type="button">
              <b-icon
                  icon="pencil"
                  size="is-small">
              </b-icon>
            </b-button>
            <b-button class="button is-small is-danger" type="button"  @click="deleteClassroom(props.row._id)">
              <b-icon
                icon="delete"
                size="is-small">
              </b-icon>
            </b-button>
          </div>
        </b-table-column>
    </b-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import SetClassroom from './SetClassroom.vue';
export default {
  name : 'classroom-table',
  data(){
      return{
        isLoading:false,
        // modalUpdateClassroom:false,
      }
  },
  components:{
    // SetClassroom
  },
	props : {
    },
    methods: {
    ...mapActions(['loadClassrooms']),
    editClassroom(id) {
      this.edit_id = id
      // this.modalUpdateClassroom= true
    },
    deleteClassroom(id) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure?',
        onConfirm: () => {
          this.deleteClassroom({ token: this.userToken, id }).then(() => {
            this.$buefy.toast.open({
              message: 'Classroom deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    },
    
    },
    computed: {
      ...mapGetters(['fetchClassrooms', 'getTeacherToken']),
    },
    created(){
      this.isLoading=true
      this.loadClassrooms({ token: this.getTeacherToken
      }).then(() => {
          this.isLoading = false
      });
    },
}
</script>
<style scoped>
.button {
  flex-direction: row;
  width: 100%;
  background: #8919e7;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  padding: 1.2vw 5vw;
  border-radius: 1.1vw;
  font-size: 1.2vw;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
</style>